import React from 'react';
import { problems } from '../data/mockData';

const ProblemSection = () => {
  return (
    <section id="problem" className="py-20 bg-gray-100 relative overflow-hidden">
      {/* Decorative diagonal shape on the right */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-200/50 transform skew-x-12 translate-x-20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left side - Title */}
          <div>
            <span className="text-[#00A86B] font-bold text-sm tracking-wider">THE PROBLEM</span>
            <h2 className="text-4xl md:text-5xl font-black text-[#0A1628] mt-4 mb-2">
              GROWTH DOESN'T
            </h2>
            <h2 className="text-4xl md:text-5xl font-black text-[#00A86B] mb-6">
              WAIT FOR BANKS
            </h2>
            <div className="w-16 h-1 bg-[#00A86B] mb-6"></div>
            
            {/* Text Logo */}
            <img 
              src="https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/dhwungns_Text%20only.png"
              alt="Waste Loan Bros"
              className="w-64 md:w-80 h-auto object-contain"
            />
          </div>

          {/* Right side - Problem cards */}
          <div className="space-y-6">
            {problems.map((problem, index) => (
              <div 
                key={index} 
                className="problem-card bg-white p-6 rounded-lg shadow-sm border-l-4 border-[#0A1628] cursor-pointer transition-all duration-300 hover:bg-[#00A86B] hover:border-[#00A86B] group"
              >
                <div className="flex items-start gap-4">
                  <span className="text-[#C2A23A] font-bold text-lg group-hover:text-white transition-colors duration-300">{problem.number}</span>
                  <div>
                    <h3 className="font-bold text-[#0A1628] text-lg mb-2 group-hover:text-white transition-colors duration-300">{problem.title}</h3>
                    <p className="text-gray-600 group-hover:text-white/90 transition-colors duration-300">{problem.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
